import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const MessageNotFound = ({ conversation_id, type }) => {
    const { filter_name } = useParams();
    const { user, active_conversation } = useSelector(state => state.message)
    return (
        <>
            {filter_name ?
                <div className='flex flex-col justify-center items-center !h-full'>
                    <h2 className='text-teal-600  text-sm text-center mmt-24 mx-7 dark:text-white'>No message found matching this filter criteria.</h2>
                </div>
                :
                <>
                    <div className='bg-[#EFECED] dark:bg-teal-700 py-5 px-5 rounded-lg flex flex-col gap-2 items-center mx-7 mt-20'>
                        <div className='privateLock text-teal-600  text-lg' />
                        <p className='text-grey-600 dark:text-white text-sm text-center'>
                            Transmission of all messages, files and calls are point-to-point encrypted.
                        </p>
                    </div>
                    <div className='flex flex-col justify-center items-center !h-[calc(100vh-440px)]'>
                        {type === 'task' ?
                            <div className="userTextArea_group flex items-center gap-3">
                                <div className="PopUpGraphic_ConvoBubble w-[15%]"></div>
                                <div className="PopUpGraphic_ConvoBubble_text w-[85%]">
                                    <p className='text-white dark:text-white text-xs'>Write your first message or upload a file to start with.</p>
                                </div>
                            </div>
                            :
                            conversation_id === user?.id ?
                                <>
                                    <div className="userTextArea_group flex items-center gap-3">
                                        <div className="PopUpGraphic_ConvoBubble w-[15%]"></div>
                                        <div className="PopUpGraphic_ConvoBubble_text w-[85%]">
                                            <h2 className='text-white text-sm text-left dark:text-white'>Welcome to the You Channel!</h2>
                                            <p className='text-white text-xs'>It's your personal room which only you have access to.You can use this space to store notes, links and files!</p>
                                        </div>
                                    </div>
                                </>
                                : (active_conversation?.id !== conversation_id && active_conversation?.group === 'no') ?
                                    <>
                                        <div className="userTextArea_group flex items-center gap-3">
                                            <div className="PopUpGraphic_ConvoBubble w-[15%]"></div>
                                            <div className="PopUpGraphic_ConvoBubble_text w-[85%]">
                                                <p className='text-white text-[13px]'>You’ve started a new room with {active_conversation?.title}. Use this space to chat, share files, and collaborate.</p>
                                            </div>
                                        </div>
                                    </>
                                    :
                                    <>
                                        <div className="userTextArea_group flex items-center gap-3">
                                            <div className="PopUpGraphic_ConvoBubble w-[15%]"></div>
                                            <div className="PopUpGraphic_ConvoBubble_text w-[85%]">
                                                <h2 className='text-white text-sm text-left dark:text-white'>Welcome to the Group!</h2>
                                                <p className='text-white text-xs'>Write your first message or upload a file to start with.</p>
                                            </div>
                                        </div>
                                    </>
                        }
                    </div>
                </>
            }
        </>
    );
};

export default MessageNotFound;